var React = require('react');

function FreeShipping (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeLinecap":"round","strokeLinejoin":"round","transform":"translate(1 1)"},[React.createElement("path",{"d":"M10.182 2.47h4.363L16 6.707v3.176h-1.855M10.582 9.882H5.81M1.818 9.882H0V0h10.182v7.059","key":0}),React.createElement("ellipse",{"cx":"3.818","cy":"10.059","rx":"2","ry":"1.941","key":1}),React.createElement("ellipse",{"cx":"12.364","cy":"10.235","rx":"1.818","ry":"1.765","key":2})]));
}

FreeShipping.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14"};

module.exports = FreeShipping;

FreeShipping.default = FreeShipping;
